import { AppLink, formatDateTime, Panel } from "@amber/ui";
import type { BudgetsResponse } from "../../contracts/index";
import { Table, Td, Th } from "./parts";

function revisionsNote(n: number): string {
  if (n === 0) return "initial values";
  return n === 1 ? "1 revision" : `${String(n)} revisions`;
}

export function RevisionsPanel({ data }: { data: BudgetsResponse }) {
  const n = data.revisions.length;
  return (
    <Panel
      title="Revision history"
      note={revisionsNote(n)}
      actions={
        <AppLink href="/settings/audit?action=operations" className="text-md font-strong text-link">
          Open in audit log
        </AppLink>
      }
    >
      <Table
        label="Revision history"
        minWidth={640}
        head={
          <>
            <Th>When</Th>
            <Th>Who</Th>
            <Th>Change</Th>
            <Th>Reason</Th>
          </>
        }
      >
        {n === 0 ? (
          <tr>
            <Td colSpan={4}>Initial values, not changed yet</Td>
          </tr>
        ) : null}
        {data.revisions.map((r) => (
          <tr key={r.revision}>
            <Td className="whitespace-nowrap">{formatDateTime(r.at)}</Td>
            <Td className="text-fg">{r.by}</Td>
            <Td className="text-md">
              <del className="text-muted decoration-attention">{r.before}</del>
              <span className="mx-1 text-muted">→</span>
              <ins className="text-fg no-underline">{r.after}</ins>
            </Td>
            <Td className="text-fg">{r.reason}</Td>
          </tr>
        ))}
      </Table>
    </Panel>
  );
}
